<template>
    <v-dialog v-model="dialogChangeRanking" max-width="350px" @click:outside="closeDialog" @keydown.esc="closeDialog">
        <v-card>
            <v-card-title>{{ dialogTitle }}</v-card-title>
            <v-card-text>
                Möchten Sie den Ranking des Beitrages jetzt von "{{ rankingOptions[article.ranking] }}" auf "{{ rankingOptions[rankingToSet] }}" ändern?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeDialog">Abbrechen</v-btn>
                <v-btn color="primary" elevation="0" @click="changeRankingConfirm">Ok</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {RepositoryFactory} from "@/repositories/RepositoryFactory";

    const ArticlesRepository = RepositoryFactory.get('articles');

    export default {
        name: "DialogChangeArticleRanking",
        props: {
            dialogChangeRanking: Boolean,
            rankingToSet: String,
            article: Object,
            dialogTitle: String,
            rankingOptions: Object,
        },
        data() {
            return {
                sendMail: false,
            }
        },
        methods: {
            changeRankingConfirm() {
                ArticlesRepository.setRanking(this.article.id, this.rankingToSet)
                .then(response => {
                    this.$emit('changeRankingConfirm', response.data);
                })
                .catch( error => {
                    console.log(error);
                        this.$emit('changeRankingConfirm', false)
                    }
                );
            },
            closeDialog () {
                this.$emit('closeDialog', this.checkToAdd);
            }
        }
    }
</script>

<style scoped>

</style>
